export const ACTIONS = [{ name: 'Webhook de atividades stays', id: 'stays' }]
